import httpClient from '@/http-client'

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/student-healths/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-healths', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const healthCategory = (options = {}) => {
  return httpClient
    .get('/api/student-healths/health-categories', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getProgramByStudent = id => {
  return httpClient
    .get(`/api/student-healths/programs/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const hospitalProfile = (options = {}) => {
  return httpClient
    .get('/api/student-healths/hospital-profiles', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  find,
  store,
  healthCategory,
  getProgramByStudent,
  hospitalProfile
}
